import { OPEN_CALL_QUERY_PARAMS, UTM_SOURCE } from '../Auth';

export const useOpenCallRedirect = () => {
  const openCall = sessionStorage.getItem(UTM_SOURCE) === OPEN_CALL_QUERY_PARAMS.utm_source;
  return { redirectToOpenCall: openCall };
};
